import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["name", "editLink", "youBadge", "deleteButton"];
  static values = { id: Number };

  connect() {
    const currentMembershipId = this.getCurrentMembershipId();
    const isCurrentUser =
      currentMembershipId && this.idValue === currentMembershipId;

    if (isCurrentUser) {
      if (this.hasYouBadgeTarget) {
        this.youBadgeTarget.classList.remove("d-none");
      }

      if (this.hasEditLinkTarget) {
        this.editLinkTarget.classList.remove("d-none");
      }
    }

    const canManage = this.canManageMemberships();
    if (canManage && !isCurrentUser && this.hasDeleteButtonTarget) {
      this.deleteButtonTarget.classList.remove("d-none");
    }
  }

  getCurrentMembershipId() {
    const meta = document.querySelector('meta[name="current-membership-id"]');
    return meta ? parseInt(meta.content, 10) : null;
  }

  canManageMemberships() {
    const meta = document.querySelector(
      'meta[name="can-manage-memberships"]'
    );
    return meta ? meta.content === "true" : false;
  }
}
